import React, { FC } from 'react';
import { PortalDialog } from '@component/Portal';
import { Modal } from '@app/react/uikit/Modal';
import { IinitState } from '@app/react/reducer/PartsSelectReducer';

export interface CartInErrorDialogProps {
    isShow: boolean;
    closeErrorDialog: () => void;
    customizeData: IinitState;
}

export const CartInErrorDialog: FC<CartInErrorDialogProps> = (props) => {
    const { isShow = false, closeErrorDialog, customizeData } = props;

    const requiredParts = [];
    if (customizeData.shaft === null) {
        requiredParts.push('シャフト');
    }
    if (customizeData.feather === null) {
        requiredParts.push('羽根');
    }
    if (customizeData.thread === null) {
        requiredParts.push('糸・和紙');
    }
    if (customizeData.kebiki === null) {
        requiredParts.push('毛引き');
    }
    if (customizeData.nock === null) {
        requiredParts.push('矢筈');
    }
    if (customizeData.arrowhead === null) {
        requiredParts.push('矢尻');
    }
    if (customizeData.arrowlength === null) {
        requiredParts.push('矢尺');
    }

    return (
        <PortalDialog className="cart-in-dialog">
            <Modal show={isShow} setShow={() => false}>
                <span className="title">
                    {requiredParts.map((part) => `${part}, `)}
                    が選択されていないためカートに追加することができませんでした。
                </span>

                <div className="footer">
                    <button type="button" className="next" onClick={closeErrorDialog}>
                        閉じる
                    </button>
                </div>
            </Modal>
        </PortalDialog>
    );
};
